import { render, staticRenderFns } from "./BillTO.vue?vue&type=template&id=312b230f&scoped=true&"
import script from "./BillTO.vue?vue&type=script&lang=js&"
export * from "./BillTO.vue?vue&type=script&lang=js&"
import style0 from "./BillTO.vue?vue&type=style&index=0&id=312b230f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b230f",
  null
  
)

export default component.exports